(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["load-more-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('load-more')) {
    class LoadMore extends HTMLElement {
      static sessionRestored = false;
      static scrollTrackingInit = false;
      static STORAGE_PREFIX = 'theme:load-more:';
      static TOP_SCROLL_THRESHOLD = 100;
      static INTERSECTION_ROOT_MARGIN = '400px 0px';

      constructor() {
        super();
        this.link = this.querySelector('.load-more__link');
        this.formStatus = this.querySelector('.load-more__status');
        this.loader = this.querySelector('[data-loader]');
        this.sectionId = this.dataset.sectionId;
        this.isRestoring = false;
        this.boundOnFiltersUpdate = this.onFiltersUpdate.bind(this);
        this.boundOnIntersect = this.onIntersect.bind(this);

        this.observer = new IntersectionObserver(this.boundOnIntersect, {
          rootMargin: LoadMore.INTERSECTION_ROOT_MARGIN,
          threshold: 0,
        });
        this.observer.observe(this);

        document.addEventListener('theme:filters:update', this.boundOnFiltersUpdate);
      }

      connectedCallback() {
        const serverPage = parseInt(this.dataset.page, 10) || 1;
        if (serverPage > 1) {
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          window.location.replace(`${url.pathname}${url.search}`);
          return;
        }

        this.initSessionTracking();
        this.restoreSession();
      }

      disconnectedCallback() {
        document.removeEventListener('theme:filters:update', this.boundOnFiltersUpdate);
        this.observer?.disconnect();
      }

      getSessionKey() {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        return `${LoadMore.STORAGE_PREFIX}${url.pathname}${url.search}`;
      }

      getSession() {
        try {
          const raw = sessionStorage.getItem(this.getSessionKey());
          return raw ? JSON.parse(raw) : null;
        } catch {
          return null;
        }
      }

      saveSession() {
        const pages = [...document.querySelectorAll('[data-product-item]')].map((item) =>
          parseInt(item.dataset.page, 10)
        );
        if (!pages.length) return;

        sessionStorage.setItem(
          this.getSessionKey(),
          JSON.stringify({
            pagesLoaded: Math.max(...pages),
            scrollY: window.scrollY,
          })
        );
      }

      clearSession() {
        sessionStorage.removeItem(this.getSessionKey());
      }

      initSessionTracking() {
        if (LoadMore.scrollTrackingInit) return;
        LoadMore.scrollTrackingInit = true;

        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        const url = new URL(window.location.href);
        if (url.searchParams.has('page')) {
          url.searchParams.delete('page');
          history.replaceState({}, '', `${url.pathname}${url.search}`);
        }

        let scrollTimeout;
        window.addEventListener(
          'scroll',
          () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              document.querySelector('load-more')?.saveSession();
            }, 150);
          },
          { passive: true }
        );
      }

      buildPageHref(page) {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (page > 1) {
          url.searchParams.set('page', String(page));
        }
        return `${url.pathname}${url.search}`;
      }

      createFetchUrl(page) {
        const url = new URL(this.buildPageHref(page), window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        return url;
      }

      async fetchPage(page) {
        const url = this.createFetchUrl(page);
        const response = await fetch(url);
        return response.text();
      }

      getMaxScrollY() {
        return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      }

      canReachScrollY(targetScrollY) {
        return this.getMaxScrollY() >= targetScrollY;
      }

      scrollToSavedPosition(targetScrollY) {
        requestAnimationFrame(() => {
          window.scrollTo({ top: Math.min(targetScrollY, this.getMaxScrollY()), behavior: 'instant' });
          this.saveSession();
        });
      }

      async restoreSession() {
        if (LoadMore.sessionRestored || !this.link) return;
        LoadMore.sessionRestored = true;

        const session = this.getSession();
        if (!session) return;

        const targetScrollY = session.scrollY || 0;
        const maxPages = session.pagesLoaded || 1;

        if (targetScrollY <= LoadMore.TOP_SCROLL_THRESHOLD) {
          window.scrollTo({ top: 0, behavior: 'instant' });
          this.saveSession();
          return;
        }

        if (maxPages <= 1) return;

        if (this.canReachScrollY(targetScrollY)) {
          this.scrollToSavedPosition(targetScrollY);
          return;
        }

        this.isRestoring = true;
        this.observer.disconnect();
        this.enableLoading();

        try {
          for (let page = 2; page <= maxPages; page++) {
            const html = await this.fetchPage(page);
            this.renderSection(html, { skipSave: true });
            if (this.canReachScrollY(targetScrollY)) break;
          }

          this.scrollToSavedPosition(targetScrollY);
        } catch (error) {
          console.error('Error restoring collection scroll session:', error);
          this.clearSession();
        } finally {
          this.disableLoading();
          this.isRestoring = false;
          this.observer.observe(this);
        }
      }

      onIntersect(entries) {
        const entry = entries[0];
        if (
          !entry?.isIntersecting ||
          this.isRestoring ||
          this.dataset.isLoading === 'true' ||
          !this.link ||
          this.style.display === 'none'
        )
          return;

        this.loadNextPage();
      }

      onFiltersUpdate(e) {
        this.clearSession();
        LoadMore.sessionRestored = false;

        const searchParams = e.detail.searchParams;
        if (!this.link || !(searchParams instanceof URLSearchParams)) return;

        const url = new URL(window.location.pathname, window.location.origin);
        for (const [key, value] of searchParams.entries()) {
          url.searchParams.append(key, value);
        }
        url.searchParams.set('page', '1');
        url.searchParams.set('section_id', this.sectionId);

        this.checkIfNextPageExistsAfterFilters(url);
      }

      async checkIfNextPageExistsAfterFilters(url) {
        try {
          const response = await fetch(url);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fetchedLoadMore = doc.querySelector('load-more');

          if (fetchedLoadMore?.dataset.hasNext === 'true') {
            const nextUrl = new URL(url);
            nextUrl.searchParams.delete('section_id');
            nextUrl.searchParams.set('page', '2');
            this.link.href = nextUrl.toString();
            this.style.display = '';
          } else {
            this.style.display = 'none';
          }
        } catch (error) {
          console.error('Error checking if next page exists after filters:', error);
          this.style.display = 'none';
        }
      }

      async loadNextPage() {
        if (!this.link) return;

        this.enableLoading();

        try {
          const url = new URL(this.link.href, window.location.origin);
          url.searchParams.set('section_id', this.sectionId);

          const response = await fetch(url);
          const html = await response.text();

          this.disableLoading();
          this.renderSection(html);
          document.dispatchEvent(new CustomEvent('theme:collection:loaded'));
        } catch (error) {
          console.error('Error loading more products:', error);
          this.disableLoading();
        }
      }

      renderSection(html, options = {}) {
        const fetchedDoc = new DOMParser().parseFromString(html, 'text/html');
        const wrapper = fetchedDoc.querySelector('[data-products-wrapper]');
        const productsWrapper = document.querySelector('[data-products-wrapper]');

        const newProducts = wrapper
          ? [...wrapper.querySelectorAll('[data-product-item]')].map((item) => item.outerHTML)
          : [];

        if (productsWrapper && newProducts.length > 0) {
          productsWrapper.insertAdjacentHTML('beforeend', newProducts.join(''));
        }

        const newLoadMore = fetchedDoc.querySelector('load-more');
        const newLink = newLoadMore?.querySelector('.load-more__link');

        if (newLink && this.link) {
          this.link.href = newLink.href;
          this.style.display = '';
        } else {
          this.style.display = 'none';
        }

        if (newLoadMore?.dataset.page) {
          this.dataset.page = newLoadMore.dataset.page;
        }

        if (!options.skipSave) {
          this.saveSession();
        }

        if (window.Shopify?.PageClickParser) {
          window.Shopify.PageClickParser.trigger(productsWrapper);
        }
      }

      enableLoading() {
        this.link?.setAttribute('aria-disabled', 'true');
        this.setAttribute('data-is-loading', 'true');
        document.activeElement?.blur();
        this.formStatus.setAttribute('aria-hidden', 'false');
        this.loader?.removeAttribute('hidden');
      }

      disableLoading() {
        this.removeAttribute('data-is-loading');
        this.formStatus.setAttribute('aria-hidden', 'true');
        this.loader?.setAttribute('hidden', '');
        this.link?.removeAttribute('aria-disabled');
      }
    }

    customElements.define('load-more', LoadMore);
  }
  } catch(e) { console.error(e); }
})();

})();
